import React from 'react';
const rows = [{
  label: 'Planificación',
  before: 'Noches de domingo buscando ideas que no terminan de cerrar.',
  after: '−90% tiempo. Sesiones listas en tu tablet en solo 2 clics.'
}, {
  label: 'Seguridad',
  before: 'Inseguridad al dar clases a personas con lesiones de columna.',
  after: 'Confianza total. Bloques clínicos seguros y específicos.'
}, {
  label: 'Variedad',
  before: 'Clases mecánicas que aburren a tus alumnas más antiguas.',
  after: '+100% originalidad. Progresiones lógicas que desafían y motivan.'
}, {
  label: 'Energía',
  before: 'Llegas a tu estudio mentalmente cansada de organizar todo.',
  after: 'Cero estrés. Llegas vibrante para conectar con tus alumnas.'
}];
const bottomStats = [{
  num: '+150h',
  label: 'Ahorradas al año'
}, {
  num: '2 clics',
  label: 'Para cada clase lista'
}, {
  num: '100%',
  label: 'Profesional'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-64">
            ⚡ La transformación
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-65">
            De una instructora agotada a una{' '}
            <span className="text-primary" data-id="element-66">profesional inspirada</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-67">
            Esto es lo que cambia desde la primera semana con Megapack Pilates
            Listo en tus manos.
          </p>
        </div>

        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-68">
          <p className="text-badge-red font-black text-2xl sm:text-3xl mb-2" data-id="element-69">
            150+ horas / año
          </p>
          <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-70">
            <span className="text-badge-red font-bold" data-id="element-71">El costo real:</span>{' '}
            Planificar manualmente te quita de 3 a 5 horas por semana. Es el
            equivalente a un{' '}
            <span className="text-badge-red font-black" data-id="element-72">
              mes entero de trabajo al año
            </span>{' '}
            quemado en cuadernos, dibujos y dudas mentales.
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden mb-10" data-id="element-73">
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-74">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-75">
              SIN EL KIT (La rutina actual)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm drop-shadow-[0_0_8px_rgba(168,85,247,0.3)]" data-id="element-76">
              CON EL MEGAPACK (Pilates Listo)
            </div>
          </div>

          <div className="divide-y divide-border-light" data-id="element-77">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-78">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-79">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-80">
                    <span className="text-badge-red font-bold text-sm" data-id="element-81">✕</span>
                  </div>
                  <div data-id="element-82">
                    <p className="text-text-main font-bold text-sm mb-1" data-id="element-83">
                      {row.label}
                    </p>
                    <p className="text-text-sec font-medium" data-id="element-84">{row.before}</p>
                  </div>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-85">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-86"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-87">
                    <span className="text-check-green font-bold text-sm" data-id="element-88">
                      ✓
                    </span>
                  </div>
                  <div className="relative z-10" data-id="element-89">
                    <p className="text-primary font-bold text-sm mb-1" data-id="element-90">
                      {row.label}
                    </p>
                    <p className="text-text-main font-bold" data-id="element-91">{row.after}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 sm:gap-6" data-id="element-92">
          {bottomStats.map((s, i) => <div key={i} className="bg-bg-alt border border-primary/20 rounded-xl p-4 sm:p-6 text-center" data-id="element-93">
              <p className="text-primary font-black text-xl sm:text-3xl mb-1" data-id="element-94">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-95">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}